import axios from 'axios';
import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getFamilyFestCompanies = () => vdkEmHappinessPortalApi.get('family-fest/companies');
const getFamilyFestPickupLocations = (country, companyId) => {
    const params = {};
    if (country !== undefined)
        params.country = country;
    if (companyId)
        params.companyId = companyId;
    return vdkEmHappinessPortalApi.get('family-fest/pickup-locations', Object.keys(params).length > 0 ? { params } : undefined);
};
const getFamilyFestAttendees = (eventId, request) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/attendees`, request);
const getFamilyFestWaitlist = (eventId, request) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/waitlist`, request);
const getFamilyFestWaitlistInvitePreview = (eventId) => vdkEmHappinessPortalApi.get(`family-fest/events/${eventId}/waitlist/invite-preview`);
const sendFamilyFestWaitlistInvitations = (eventId, slots) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/waitlist/send-invitations`, { slots });
const sendFamilyFestWaitlistLinks = (eventId, invitationIds) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/waitlist/send-links`, { invitationIds });
const getFamilyFestCapacitySlots = (eventId) => vdkEmHappinessPortalApi.get(`family-fest/events/${eventId}/waitlist/slots`);
const convertFamilyFestWaitlistSlots = (eventId, count) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/waitlist/slots/convert`, { count });
/** Runs the waitlist auto-invite job now; returns the number invited. */
const triggerFamilyFestWaitlistAutoInvite = () => vdkEmHappinessPortalApi.post('family-fest/waitlist/auto-invite/trigger');
const updateFamilyFestWaitlistPersons = (invitationId, numberOfPersons) => vdkEmHappinessPortalApi.put(`family-fest/invitations/${invitationId}/waitlist-persons`, { numberOfPersons });
const moveFamilyFestWaitlistEntry = (eventId, request) => vdkEmHappinessPortalApi.put(`family-fest/events/${eventId}/waitlist/move`, request);
const deleteFamilyFestWaitlistEntry = (invitationId) => vdkEmHappinessPortalApi.delete(`family-fest/invitations/${invitationId}/waitlist-entry`);
const getFamilyFestAttendeeDetail = (attendeeId) => vdkEmHappinessPortalApi.get(`family-fest/attendees/${attendeeId}`);
const deleteFamilyFestAttendee = (attendeeId, expireInvitation = true) => vdkEmHappinessPortalApi.delete(`family-fest/attendees/${attendeeId}`, {
    params: { expireInvitation }
});
const archiveFamilyFestAttendee = (attendeeId, body = {}) => vdkEmHappinessPortalApi.post(`family-fest/attendees/${attendeeId}/archive`, { archiveReason: body.archiveReason ?? undefined });
const offboardFamilyFestAttendee = (attendeeId) => vdkEmHappinessPortalApi.post(`family-fest/attendees/${attendeeId}/offboard`, {});
const unarchiveFamilyFestAttendee = (attendeeId) => vdkEmHappinessPortalApi.post(`family-fest/attendees/${attendeeId}/unarchive`, {});
const generateFamilyFestInviteLink = (attendeeId) => vdkEmHappinessPortalApi.post(`family-fest/attendees/${attendeeId}/generate-link`, {});
const registerFamilyFestAttendeeAdmin = (eventId, body) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/attendees/register-admin`, body);
const updateFamilyFestAttendee = (attendeeId, body) => vdkEmHappinessPortalApi.put(`family-fest/attendees/${attendeeId}`, body);
const completeFamilyFestRegistration = (body) => vdkEmHappinessPortalApi.put('family-fest/registration/complete', body);
const getAllParkingSlots = (request) => vdkEmHappinessPortalApi.post('family-fest/get-all-parking-slots', request);
const getAllAccommodations = (request) => vdkEmHappinessPortalApi.post('family-fest/accommodations', request);
const AllotteAccommodationToAttendee = (request) => vdkEmHappinessPortalApi.post("/family-fest/attendees/accommodation/allottement", request);
const getCarAccommodationEligibleAttendees = (eventId, request) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/accommodation/car-eligible`, request);
const moveToCarAccommodation = (request) => vdkEmHappinessPortalApi.post('family-fest/attendees/accommodation/move-to-accommodation', request);
/** Server-generated .xlsx with Active and Archive worksheets. */
const downloadFamilyFestAttendeesExcel = async (eventId) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/attendees/export-excel`, undefined, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = 'family-fest-attendees.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        // With responseType: 'blob', error bodies are a Blob — read text so toasts aren't empty.
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            throw new Error(text || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
const downloadFamilyFestAccommodationExcel = async (eventId) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/attendees/export-accommodation-excel`, undefined, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = 'family-fest-accommodation.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            throw new Error(text || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
const getFamilyFestDashboardCharts = (eventId) => vdkEmHappinessPortalApi.get(`family-fest/events/${eventId}/dashboard/charts`);
const getFamilyFestAnalytics = (eventId) => vdkEmHappinessPortalApi.get(`family-fest/events/${eventId}/dashboard/analytics`);
const getFamilyFestTotalResponses = (eventId) => vdkEmHappinessPortalApi.get(`family-fest/events/${eventId}/dashboard/total-responses`);
const generatePassportOtp = (eventId) => vdkEmHappinessPortalApi.post('family-fest/passport/otp/generate', { eventId });
const verifyPassportOtp = (otp) => vdkEmHappinessPortalApi.post('family-fest/passport/otp/verify', {
    otp
});
const getFamilyFestPassports = (query) => vdkEmHappinessPortalApi.post('family-fest/passport/get-all', query);
const getPassportAuditLogs = (eventId, query) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/passports/audit-logs`, query);
const downloadFamilyFestPassportsExport = async (query) => {
    try {
        const response = await vdkEmHappinessPortalApi.post(`family-fest/passport/export-excel`, query, { responseType: 'blob' });
        const headers = response.headers;
        const contentType = headers['content-type'] ??
            headers['Content-Type'] ??
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const cd = headers['content-disposition'] ?? headers['Content-Disposition'] ?? '';
        let filename = query.exportFormat === 'csv' ? 'family-fest-passports.csv' : 'family-fest-passports.xlsx';
        const m = cd.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (m?.[1]) {
            filename = m[1].replace(/['"]/g, '');
            try {
                filename = decodeURIComponent(filename);
            }
            catch {
                /* keep raw */
            }
        }
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
            const text = (await error.response.data.text()).trim();
            throw new Error(text || 'Export failed');
        }
        throw error instanceof Error ? error : new Error('Export failed');
    }
};
const updateFamilyFestEventSpots = (query) => {
    return vdkEmHappinessPortalApi.put(`/family-fest/events/spots`, query);
};
const getFamilyFestCompanyAttendees = (eventId) => {
    return vdkEmHappinessPortalApi.get(`/family-fest/events/${eventId}/company-attendees`);
};
const getFamilyFestCompanyAttendeesGrid = (eventId, request) => {
    return vdkEmHappinessPortalApi.post(`/family-fest/events/${eventId}/company-attendees`, request);
};
const resendFamilyFestInvitationEmail = (attendeeId) => vdkEmHappinessPortalApi.post(`family-fest/attendees/${attendeeId}/resend-invitation`, {});
const sendFamilyFestReminderEmail = (attendeeIds) => vdkEmHappinessPortalApi.post('family-fest/attendees/send-reminder-email', { attendeeIds });
const getFamilyFestReminderEligibleAttendees = (eventId, pageNumber, pageSize) => vdkEmHappinessPortalApi.post(`family-fest/events/${eventId}/attendees/reminder-eligible`, { pageNumber, pageSize });
const familyFestApi = {
    getFamilyFestCompanies,
    getFamilyFestPickupLocations,
    getFamilyFestAttendees,
    getFamilyFestWaitlist,
    sendFamilyFestWaitlistInvitations,
    sendFamilyFestWaitlistLinks,
    getFamilyFestCapacitySlots,
    convertFamilyFestWaitlistSlots,
    triggerFamilyFestWaitlistAutoInvite,
    updateFamilyFestWaitlistPersons,
    deleteFamilyFestWaitlistEntry,
    moveFamilyFestWaitlistEntry,
    getFamilyFestWaitlistInvitePreview,
    getFamilyFestAttendeeDetail,
    deleteFamilyFestAttendee,
    archiveFamilyFestAttendee,
    offboardFamilyFestAttendee,
    unarchiveFamilyFestAttendee,
    generateFamilyFestInviteLink,
    registerFamilyFestAttendeeAdmin,
    updateFamilyFestAttendee,
    completeFamilyFestRegistration,
    downloadFamilyFestAttendeesExcel,
    downloadFamilyFestAccommodationExcel,
    getAllParkingSlots,
    getAllAccommodations,
    getFamilyFestDashboardCharts,
    getFamilyFestAnalytics,
    getFamilyFestTotalResponses,
    AllotteAccommodationToAttendee,
    getCarAccommodationEligibleAttendees,
    moveToCarAccommodation,
    generatePassportOtp,
    verifyPassportOtp,
    getFamilyFestPassports,
    getPassportAuditLogs,
    downloadFamilyFestPassportsExport,
    updateFamilyFestEventSpots,
    getFamilyFestCompanyAttendees,
    getFamilyFestCompanyAttendeesGrid,
    resendFamilyFestInvitationEmail,
    sendFamilyFestReminderEmail,
    getFamilyFestReminderEligibleAttendees
};
export default familyFestApi;
